"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVipps = function IconVipps(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12.194 15.741c2.612 0 4.094-1.27 5.506-3.106.776-.988 1.765-1.2 2.47-.635s.777 1.624 0 2.612c-2.047 2.682-4.658 4.306-7.976 4.306-3.6 0-6.777-1.977-8.965-5.436-.635-.917-.494-1.905.212-2.4s1.765-.282 2.4.706c1.553 2.33 3.67 3.953 6.353 3.953m4.87-8.682c0 1.27-.988 2.117-2.117 2.117s-2.118-.847-2.118-2.117.989-2.118 2.118-2.118 2.117.918 2.117 2.118"
  })));
};

export { IconVipps, IconVipps as default };
